import React, { ReactElement } from "react";
import AdditionalControlForm from "./AdditionalControlForm";

export interface AdditionalControlFormContent {
  name: string;
  value: number;
  unit?: string;
  onSubmit: () => Promise<void>;
}

export default function AdditionalControlForms({
  contents,
}: {
  contents: AdditionalControlFormContent[];
}): ReactElement {
  return (
    <div>
      {contents.map((c, i) => (
        <div style={{ marginTop: "15px" }} key={i}>
          <AdditionalControlForm
            onSubmit={c.onSubmit}
            defaultValue={c.value}
            label={c.name}
            unit={c.unit}
          />
        </div>
      ))}
    </div>
  );
}
